import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./contexts/AuthContext";
import { BrowserRouter } from "react-router-dom";
import LogRocket from "logrocket";
import Router from "./Router";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";
import ProductionDebugPanel from "./components/ProductionDebugPanel";
import vercelLogger from "./utils/vercelRuntimeLogger";

// Initialize LogRocket at the very beginning
LogRocket.init("instant-3d/instant3d");

// Initialize Vercel logger session
if (typeof window !== 'undefined') {
  const correlationId = vercelLogger.createCorrelationId('bootstrap');
  vercelLogger.info('App', 'APP_INIT', {
    correlationId,
    userAgent: navigator.userAgent,
    url: window.location.href,
    release: vercelLogger.getSessionInfo().release,
    timestamp: new Date().toISOString(),
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Router />
          <Toaster />
          <ProductionDebugPanel enabled={process.env.REACT_APP_ENABLE_PRODUCTION_LOGGING === 'true'} />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
